import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import ColorPicker from './ColorPicker.js';
import BorderPicker from './BorderPicker.js';
import PaddingPicker from './PaddingPicker.js';

import SidebarElementHeader from './SidebarElementHeader.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';


import FontPicker from './FontPicker.js';




class SidebarPageElement extends React.Component {
	constructor(props) {	
		super(props);
		
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleColorChange = this.handleColorChange.bind(this);
		this.handleBorderChange = this.handleBorderChange.bind(this);
		this.onPaddingChange = this.onPaddingChange.bind(this);
        this.outputRule = this.outputRule.bind(this);
        this.handleSubjectChange = this.handleSubjectChange.bind(this);
	}

    handleSubjectChange(e) {
        this.props.setGlobalTypeState('page',false,{'subject':e.target.value});
    }


    el() {
    	return this.props.builder.components[this.props.id];
    }

    renderSettings() {
    	return <div><SidebarElementSpacing text='Settings' />Dette er en test</div>;
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
    	this.props.setComponentState(this.el().id,{value:v});
    }

    handleColorChange(id,color) {
    	let changes = {};
    	changes[id] = color;
		this.props.setGlobalTypeState('page',false,changes);
    }

    handleBorderChange(id,border) {
    	let changes = {};
    	changes[id] = border;    	
		this.props.setGlobalTypeState('page',false,changes);
    }

    onPaddingChange(id,padding) {
		let changes = {};
    	changes[id] = padding;    	
		this.props.setGlobalTypeState('page',false,changes);
    }

    outputRule(rule) {
        const Comp = this.props.components['Rule'+rule.key];
        return <Comp setGlobalTypeState={this.props.setGlobalTypeState} rule={rule} key={rule.id} />
    }

    render() {
        const rule_options = [
            {
                'value':'mobile',
                'label':'mobile'
            },
            {
                'value':'desktop',
                'label':'desktop'
            },
            {
                'value':'both',
                'label':'both'
            }
        ]



    	return(
    		<div className="settings m-t-20" style={this.props.style}>


                <div className="panel-group panel-group-continuous" id="sidebar-settings" aria-multiselectable="true" role="tablist">
                    <SidebarSettingAccordion selectedSetting={this.props.selectedSetting} optionKey="email" parent="sidebar-settings" title="E-mail options">
                        <SidebarElementSetting text="E-mail subject">
                            <input type="text" className="form-control" onChange={this.handleSubjectChange} value={this.props.subject} placeholder="Subject" />
                        </SidebarElementSetting>
                    </SidebarSettingAccordion>

                    <SidebarSettingAccordion selectedSetting={this.props.selectedSetting} optionKey="layout" parent="sidebar-settings" title="Layout">
                        
                        <SidebarElementSetting text="Font style">
                            <FontPicker 
                                    fontId='font' 
                                    sizeId='fontSize'
                                    colorId='color'
                                    font={this.props.page.font} 
                                    size={this.props.page.fontSize}
                                    color={this.props.page.color} 
                                    handleChange={this.handleBorderChange} 
                                />
                        </SidebarElementSetting>
                                
                        <SidebarElementSetting text="Background color">
                            <ColorPicker id='backgroundColor' color={this.props.page.backgroundColor} handleColorChange={this.handleColorChange} />
                        </SidebarElementSetting>

                        <SidebarElementSetting text="Border top">
                            <BorderPicker id='borderTop' handleBorderChange={this.handleBorderChange} data={this.props.page.borderTop} handleColorChange={this.handleColorChange} />
                        </SidebarElementSetting>

                        <SidebarElementSetting text="Border bottom">
                            <BorderPicker id='borderBottom' handleBorderChange={this.handleBorderChange} data={this.props.page.borderBottom} handleColorChange={this.handleColorChange} />
                        </SidebarElementSetting>
 
                    </SidebarSettingAccordion>
                    {
                        this.props.page.type == 'NEWSLETTER' || this.props.isUsingFlow ? null
                            :
                        <SidebarSettingAccordion selectedSetting={this.props.selectedSetting} optionKey="who" parent="sidebar-settings" title="Who">

                            <div>
                                <div className="list-group bg-blue-grey-100 bg-inherit">
                                    {
                                        Object.keys(this.props.rules).map((i) => {
                                            if(this.props.rules[i].action != 'Who') {
                                                return null;
                                            }
                                            return this.outputRule(this.props.rules[i]);
                                        })
                                    }
                                </div>



                            </div>

                        </SidebarSettingAccordion>
                    }

                    {
                        this.props.page.type == 'NEWSLETTER' || this.props.isUsingFlow ? null
                            :
                        <SidebarSettingAccordion selectedSetting={this.props.selectedSetting} optionKey="when" parent="sidebar-settings" title="When">
                            <div className="list-group bg-blue-grey-100 bg-inherit">
                                {
                                    Object.keys(this.props.rules).map((i) => {
                                        if(this.props.rules[i].action != 'When') {
                                            return null;
                                        }

                                        return this.outputRule(this.props.rules[i]);
                                    })
                                }
                            </div>
                        </SidebarSettingAccordion>
                    }
                </div>

    			


    		</div>
		);
    }
}

export default SidebarPageElement;





// WEBPACK FOOTER //
// ./components/builder/SidebarPageElement.js